import { StanBanner } from '@/components';
import IcInfo from '@/assets/icons/ic-info-circle.svg';
import { PageStatus } from '@/types/store';
import type { FunnelPageItem, FunnelRouteTarget } from '../../../types';

interface BrokenRouteWarningProps {
    target: FunnelRouteTarget | null | undefined;
    allPages: FunnelPageItem[];
    eventLabel: string;
}

/**
 * Renders a warning banner tied to a single routing row (on_purchase / on_skip)
 * if that row's target is missing or hidden. Returns null otherwise.
 */
export const BrokenRouteWarning = ({ target, allPages, eventLabel }: BrokenRouteWarningProps) => {
    if (!target) return null;
    const page = allPages.find(p => p.page_id === target.page_id);

    if (!page) {
        return (
            <StanBanner
                variant='warning'
                icon={IcInfo}
                title='Routing target no longer exists'
                subtitle={`The page customers were being sent to after they ${eventLabel} has been deleted. Customers will fall back to the next step until you pick a new destination.`}
            />
        );
    }

    if (page.status === PageStatus.DRAFT) {
        return (
            <StanBanner
                variant='warning'
                icon={IcInfo}
                title='Routing target is hidden'
                subtitle={`The page customers are sent to after they ${eventLabel} is currently hidden. Customers will fall back to the next step until you unhide it or pick a different destination.`}
            />
        );
    }

    return null;
};
